module.exports = __webpack_public_path__ + "static/images/new-tag.47b466c.png";